<template>
  <div v-if="compyinfo">
    <div class="flex align-start m-b-15">
      <div class="flex-grow flex flex-column align-initial">
        <div class="search-cont com-model m-b-15">
          <input type="password" style="display: none; opacity: 0; height: 0; padding: 0;"/>
          <el-input class="search-box m-b-16"
                    placeholder="请输入岗位名搜索全网人才"
                    @keyup.enter="search"
                    v-model="searchWord"
                    autocomplete="off"
                    style="width: calc(100% - 4px);">
            <i class="el-icon-search" slot="prepend"/>
            <div style="cursor: pointer;" slot="append" @click="search(searchWord)">搜人才</div>
          </el-input>
          <div class="flex flex-between">
            <div class="flex flex-grow" style="flex-shrink: 1; overflow: hidden; margin-right: 30px;">
              <div class="label">热门搜索</div>
              <template v-for="(item, index) in hotwordList">
                <div class="ls-item" v-if="index < 3" :key="index" @click="search(item.value)">{{item.value}}</div>
              </template>
            </div>
            <div class="flex flex-shrink">
              <div class="tip  flex-shrink">希望主动求职者投递？</div>
              <router-link to="/index/posts/release" class="out-line" type="primary">
                <i class="el-icon-plus"/>发布岗位
              </router-link>
            </div>
          </div>
        </div>
        <div class="compy-info com-model">
          <div class="top flex flex-between align-start m-b-15">
            <div class="flex">
              <div class="compy-logo flex flex-center">
                <img :src="compyinfo.logo" alt="公司头像"/>
              </div>
              <div class="flex flex-column flex-between align-initial">
                <div>
                  <div class="top-title flex m-b-10">
                    <div class="m-r-16">{{compyinfo.name}}</div>
                    <div class="auth-ing" v-if="compyinfo.isAuth === 2">认证中</div>
                    <router-link to="/index/company/auth"
                                 class="no-auth flex flex-center"
                                 v-else-if="compyinfo.isAuth === 0">
                      立即认证
                      <img style="width: 18px; height: 18px; margin-left: 5px;"
                           src="../../assets/images/home/renzhen_icon.png"
                           alt=""/>
                    </router-link>
                  </div>
                  <div class="flex flex-between m-b-16">
                    <div class="flex" style="margin-right: 70px;">
                      <div class="appraise-tit">用户综合评分：</div>
                      <star-temp :star-num=$store.state.hrinfo.fullEval class="startemp"></star-temp>
                    </div>
                    <router-link to="/index/home/valuation"
                                 v-if="$store.state.hrinfo.fullEval"
                                 class="flex flex-end appraise-see">
                      查看评分<i class="el-icon-arrow-right"/>
                    </router-link>
                    <div v-else class="appraise-see">暂无评价</div>
                  </div>
                </div>
                <div class="flex">
                  <img class="m-r-30" style="width: 44px; height: 31px;"
                       src="../../assets/images/home/vip_icon.png"
                       v-if="compyinfo.isVip"
                       alt=""/>
                  <img class="m-r-30" style="width: 44px; height: 33px"
                       src="../../assets/images/home/renzhened_icon.png"
                       v-if="compyinfo.isAuth === 1"
                       alt=""/>
                  <router-link :to="{path:'/index/member/info'}"
                               class="go-vip flex flex-between"
                               v-if="!compyinfo.isVip">
                    <div class="flex">
                      <img style="width: 20px; height: 20px;"
                           src="../../assets/images/home/vip_word_icon.png"
                           alt=""/>
                      <div class="">尚未开通会员，点击去开通可享受会员权益。</div>
                    </div>
                    <div class="go">去开通 <i class="el-icon-arrow-right"></i></div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="" style="width: 130px;">
              <div class="word-show">信息完善度：{{compyinfo.perfectRate * 100}}%</div>
              <div class="progress">
                <div class="bar" :style="{width: compyinfo.perfectRate * 100 +'%'}"/>
              </div>
            </div>
          </div>
          <div class="">
            <div class="flex" style="margin-bottom: 9px;">
              <div class="label">我的余额：</div>
              <div class="value">{{compyinfo.availableFunds}}点</div>
              <div class="uinfo-b-btn" @click="gorecharge">充值</div>
              <div class="uinfo-b-btn" @click="gofinance(1)">明细</div>
            </div>
            <div class="flex" v-if="compyinfo.isVip">
              <div class="label">会员到期时间：</div>
              <div class="value">{{compyinfo.vipEnd.split(" ")[0]}}</div>
              <div class="uinfo-b-btn" @click="gomember">续费</div>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-list com-model">
        <div class="com-title flex m-b-15">
          公告通知
          <img style="width: 18px; height: 18px; margin-left: 4px;"
               src="../../assets/images/home/notice_icon.png"
               alt=""/>
        </div>
        <router-link :to="{path:'/index/home/notice'}" class="look-more">查看全部</router-link>
        <div class="carousel" id="scrollContainer">
          <div class="notice-item" v-for="item in noticeList" :key="item.id">
            <div class="content">{{item.title}}</div>
            <div class="time">{{item.createdAt.split(' ')[0]}}</div>
          </div>
          <img class="manager-img" :src="compyinfo.bizCard" alt=""/>
        </div>
      </div>
    </div>
    <div class="com-model data-show m-b-15">
      <div class="line-title m-b-22">数据概况</div>
      <div class="flex flex-between list-cont">
        <div class="box-item">
          <div class="label">待处理简历</div>
          <div class="value">{{compyinfo.waitHandleResume}}</div>
          <div class="last flex">已收简历： {{compyinfo.totalResume}}份</div>
          <router-link :to="{path:'/index/resume/list'}" class="go-more flex">前往处理
            <img style="width: 16px; height: 16px; margin-left: 8px;"
                 src="../../assets/images/home/go_to_blue_icon.png"
                 alt=""/>
          </router-link>
        </div>
        <div class="box-item">
          <div class="label">招聘中的岗位</div>
          <div class="value">{{compyinfo.recruitNum}}</div>
          <div class="last flex">剩余发布岗位数： {{compyinfo.remainRecruitNum}}个</div>
          <router-link :to="{path:'/index/posts/list'}" class="go-more flex">详情
            <img style="width: 16px; height: 16px; margin-left: 8px;"
                 src="../../assets/images/home/go_to_blue_icon.png"
                 alt=""/>
          </router-link>
        </div>
        <div class="box-item">
          <div class="label">已下载简历</div>
          <div class="value">{{compyinfo.collNum}}</div>
          <div class="last flex">剩余下载简历次数： {{compyinfo.remainCollNum}}次</div>
          <router-link :to="{path:'/index/resume/list'}" class="go-more flex">
            前往处理
            <img style="width: 16px; height: 16px; margin-left: 8px;"
                 src="../../assets/images/home/go_to_blue_icon.png"
                 alt=""/>
          </router-link>
        </div>
        <div class="box-item">
          <div class="label">已收藏简历</div>
          <div class="value">{{compyinfo.favoriteNum}}</div>
          <div class="last flex"/>
          <router-link :to="{path:'/index/resume/list', query:{index:6}}" class="go-more flex">
            前往处理
            <img style="width: 16px; height: 16px; margin-left: 8px;"
                 src="../../assets/images/home/go_to_blue_icon.png"
                 alt=""/>
          </router-link>
        </div>
        <div class="box-item">
          <div class="label">赴外招聘记录</div>
          <div class="value qr-img" @click="toRecruitmentRecord">
            <img :src="compyinfo.qrAbroadCode" alt=""/>
          </div>
          <div class="last flex">待处理： {{compyinfo.abroadNum || 0}}份</div>
          <router-link :to="{path:'/index/resume/list'}" class="go-more flex">
            前往处理
            <img style="width: 16px; height: 16px; margin-left: 8px;"
                 src="../../assets/images/home/go_to_blue_icon.png"
                 alt=""/>
          </router-link>
        </div>
        <div class="box-item yellow-bg">
          <div class="label flex flex-wrap">
            <div class="flex align-start">
              <img style="width: 27px; height: 19px; margin-right: 7px;"
                   src="../../assets/images/home/vip_icon.png"
                   alt=""/>
              会员特权
            </div>
            <router-link :to="{path:'/index/member/info'}" class="red-btn">去开通/续费</router-link>
          </div>
          <div class="line-item flex">
            <div class="line-label">剩余可下载：</div>
            <div class="line-value">{{compyinfo.remainCollNum}}次</div>
          </div>
          <div class="line-item flex">
            <div class="line-label">剩余可招聘：</div>
            <div class="line-value">{{compyinfo.remainRecruitNum}}次</div>
          </div>
        </div>
      </div>
    </div>
    <div class="com-model relative" style="padding-top: 14px; border-radius: 10px;">
      <div class="line-title m-b-30">活动</div>
      <router-link :to="{path:'/index/jobfair'}" class="look-more">更多</router-link>
      <div class="activity-list">
        <activity-item :item="item" v-for="item in zphList" :key="item.id"/>
      </div>
    </div>
    <el-dialog v-model="imageVisible" size="tiny">
      <img width="100%" :src="imageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import ActivityItem from '../../components/ActivityItem.vue';
  import valuationStar from "../../components/valuationStar.vue"; // 星星评价组件

  /**
   * @return {number}
   */
  const IEVersion = () => {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    const isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    const isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
      const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      const fIEVersion = parseFloat(RegExp["$1"]);
      if (fIEVersion === 7) {
        return 7;
      } else if (fIEVersion === 8) {
        return 8;
      } else if (fIEVersion === 9) {
        return 9;
      } else if (fIEVersion === 10) {
        return 10;
      } else {
        return 6; //IE版本<=7
      }
    } else if (isEdge) {
      return "edge"; //edge
    } else if (isIE11) {
      return 11; //IE11
    } else {
      return -1; //不是ie浏览器
    }
  };

  const downloadIamge = (selector, name) => {
    const image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      const url = canvas.toDataURL("image/png");
      // 生成一个a元素
      const a = document.createElement("a");
      // 创建一个单击事件
      const event = new MouseEvent("click");
      // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
      a.download = name || "下载图片名称";
      // 将生成的URL设置为a.href属性
      a.href = url;
      // 触发a的单击事件
      a.dispatchEvent(event);
    };
    image.src = document.querySelector(selector).src;
  };

  export default {
    data() {
      return {
        name: 1,
        compyinfo: null,
        rzstatus: 1,
        zphList: [],
        showDown: false,
        noticeList: [],
        hotwordList: [], //热词
        searchWord: '',
        imageVisible: false,
        imageUrl: ''
      };
    },
    created() {
      this.getInfo();
      this.axios.get("/wapi/activity/list?pageSize=2&pageNum=1").then(res => {
        this.zphList = res.rows;
      });
      this.axios.get("/wapi/notice/list?pageNum=1&pageSize=2").then(res => {
        if (res.code === 200) {
          this.noticeList = res.rows;
        }
      });
      this.axios.get("/wapi/hotword/list").then(res => {
        if (res.status === 200) {
          this.hotwordList = res.data;
        }
      });
    },
    components: {
      starTemp: valuationStar,
      ActivityItem
    },
    mounted() {
      setTimeout(() => {
        this.scrollToTop();
      }, 2000);
    },
    methods: {
      search(value) {
        this.$router.push({
          path: "/index/searchlist",
          query: { value: value }
        });
      },
      downloadImg(src) {
        if (src === undefined || src === "") {
          return;
        }
        if (IEVersion() === -1) {
          this.$message({
            type: "error",
            message: "请使用谷歌浏览器下载"
          });
          return;
        }
        downloadIamge("#qrCode", "公司小程序码");
      },
      goValuation() {
        this.$router.push({
          path: "/index/home/valuation"
        });
      },
      gomember() {
        this.$router.push({ path: "/index/member/info" });
      },
      gorecharge() {
        this.$router.push({ path: "/index/finance/recharge" });
      },
      gofinance(tab) {
        this.$router.push({
          path: "/index/finance/index#tab",
          query: { tab: tab }
        });
      },
      gorz() {
        this.$router.push({ path: "home/compyrz" });
      },
      gorzz() {
        this.$alert("您已提交认证资料，正在审核当中！", "认证中");
      },
      getInfo() {
        let url = "/wapi/company/detail";
        this.axios.get(url).then(res => {
          this.compyinfo = res.data;
          this.rzstatus = res.data.isAuth;
        });
      },
      scrollToTop() {
        const doc = document.getElementById('scrollContainer');
        let scrollTop = doc.scrollTop;
        const scrollHeight = doc.scrollHeight;
        const clientHeight = doc.clientHeight;
        if (scrollHeight > clientHeight) {
          const speed = 100;
          let directionType = true;
          const Marquee1 = () => {
            if (directionType) {
              doc.scrollTop += 1;
              scrollTop += 1;
              if (scrollTop === scrollHeight - clientHeight) {
                directionType = false;
              }
            } else {
              doc.scrollTop -= 1;
              scrollTop -= 1;
              if (scrollTop === 0) {
                directionType = true;
              }
            }
          };
          let MyMar1 = setInterval(Marquee1, speed);
          doc.onmouseover = () => {
            clearInterval(MyMar1);
          };
          doc.onmouseout = () => {
            MyMar1 = setInterval(Marquee1, speed);
          };
        }
      },
      toRecruitmentRecord() {
        this.imageUrl = this.compyinfo.qrAbroadCode;
        this.imageVisible = true;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import url('../../assets/less/base.less');

  .search-cont {
    padding: 19px 24px;
    height: 124px;
    box-sizing: border-box;
    font-size: 14px;
    border-radius: 10px;

    .label {
      color: #333333;
      margin-right: 16px;
      flex-shrink: 0;
    }

    .ls-item {
      height: 24px;
      line-height: 24px;
      background: #F0F0F0;
      border-radius: 12px;
      padding: 0 16px;
      color: #8F8F8F;
      margin-right: 12px;
      flex-shrink: 0;
      cursor: pointer;
    }

    .tip {
      color: #71A9DC;
      margin-right: 28px;
    }

    .out-line {
      background: transparent;
      height: 32px;
      line-height: 32px;
      border-radius: 20px;
      border: 1px solid #1890FF;
      color: #1890FF;
      padding: 0 22px;
    }
  }

  .compy-info {
    height: 218px;
    padding: 19px 24px;
    border-radius: 10px;

    .compy-logo {
      width: 166px;
      height: 114px;
      margin-right: 24px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .top-title {
      font-size: 24px;
      color: #262626;
      font-weight: 500;

      .no-auth {
        width: 100px;
        height: 32px;
        line-height: 32px;
        background: linear-gradient(180deg, #FCD47E 0%, #F5A559 100%);
        box-shadow: inset 0 1px 3px 0 rgba(255, 255, 255, 0.65);
        border-radius: 16px;
        color: #63440B;
        font-size: 14px;
      }

      .auth-ing {
        width: 70px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        box-shadow: inset 0 1px 3px 0 rgba(255, 255, 255, 0.65);
        border-radius: 16px;
        border: 1px solid #59A3E6;
        color: #63440B;
        font-size: 14px;
      }
    }

    .appraise-tit {
      font-size: 16px;
      color: #262626;
      margin-right: 9px;
    }

    .appraise-see {
      font-size: 14px;
      color: #888888;

      .el-icon-arrow-right {
        margin-left: 13px;
      }
    }

    .go-vip {
      width: 468px;
      height: 36px;
      background: #FFF1EB;
      border-radius: 4px;
      color: #707070;
      font-size: 16px;
      padding: 0 10px;
      box-sizing: border-box;

      .go {
        font-size: 16px;
        color: #FF7A45;
      }
    }

    .word-show {
      font-size: 14px;
      color: #BFBFBF;
      line-height: 20px;
      margin-bottom: 6px;
    }

    .label {
      font-size: 16px;
      color: #707070;
      margin-right: 8px;
    }

    .value {
      font-size: 16px;
      color: #262626;
      margin-right: 13px;
    }

    .uinfo-b-btn {
      font-size: 16px;
      color: #FF7A45;
      margin-right: 13px;
      cursor: pointer;
    }
  }

  .notice-list {
    width: 250px;
    overflow: hidden;
    margin-left: 15px;
    box-sizing: border-box;
    padding: 19px 24px;
    border-radius: 10px;
    position: relative;

    .carousel {
      height: 275px;
      overflow: hidden;
    }

    .notice-item {
      background: #F8F8F8;
      border-radius: 0 10px 10px 10px;
      margin-bottom: 14px;
      padding: 8px 10px;

      .content {

        font-size: 14px;
        color: #707070;
      }

      .time {
        font-size: 10px;
        color: #BCBCBC;
        text-align: right;
      }
    }

    .manager-img {
      width: 186px;
      height: 186px;
      margin-left: 6px;
    }
  }

  .line-title {
    position: relative;
    font-size: 20px;
    color: #222222;
    padding-left: 36px;
    height: 32px;
    line-height: 32px;

    &:after {
      content: "";
      width: 6px;
      height: 32px;
      display: block;
      background: #057CF9;
      position: absolute;
      top: 0;
      left: 24px;
    }

    // margin-bottom: 22px;
  }

  .data-show {
    position: relative;
    padding: 12px 0 15px;
    border-radius: 10px;

    .list-cont {
      flex-wrap: wrap;
      gap: 15px;
      padding: 0 15px;

      .box-item {
        background: #F5F8FF;
        border-radius: 8px;
        height: 173px;
        box-sizing: border-box;
        padding: 20px;
        flex-grow: 1;
        flex-shrink: 0;
        color: #67728B;

        &.yellow-bg {
          flex: 0 0 235px;
          padding: 20px;
          background-color: #FFFCF4;
          color: #6A5C38;

          .label {
            justify-content: space-between;
            margin-bottom: 20px;
          }
        }

        .qr-img {
          width: 40px;
          height: 40px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .label {
          font-size: 16px;
          color: #67728B;
          font-weight: 500;
          line-height: 22px;
          margin-bottom: 6px;
        }

        .value {
          line-height: 40px;
          color: #057CF9;
          font-size: 28px;
          margin-bottom: 8px;

          img {
            height: 100%;
            width: auto;
          }
        }

        .last {
          height: 21px;
          line-height: 21px;
          font-size: 14px;
          color: #67728B;
          margin-bottom: 16px;
        }

        .go-more {
          font-size: 14px;
          color: #057CF9;
        }

        .red-btn {
          width: 77px;
          height: 20px;
          background: #FF7A45;
          border-radius: 4px;
          line-height: 20px;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
        }

        .line-item {
          line-height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #6A5C38;
          margin-bottom: 16px;

          .line-label {
            width: 112px;
          }

          .line-value {
            color: #333333;
            font-weight: 500;
          }
        }
      }
    }
  }

  .activity-list {
    padding: 0 24px;
  }
</style>



// WEBPACK FOOTER //
// home.vue?10332988